import { compose, space as styledSpace } from 'styled-system';
import margin from './margin';
import padding from './padding';

const space = compose(styledSpace, margin, padding);
space.css = (type, value) => (props) =>
  space[type]({ theme: props.theme, [type]: value });
export default space;
